import { common_urls } from './environments/environment';
import { FetchMenuService } from '@cws-ui/ngx-cws-app-layout';
import { APP_INITIALIZER, Renderer2, RendererFactory2, importProvidersFrom } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { AuthConfigModule } from './app/auth/auth-config.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { translateConfig } from './app/translate-config';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { CdsProgressModule } from '@cds/ng-web-components/progress';
import { MatNativeDateModule } from '@angular/material/core';
import { AppComponent } from './app/app.component';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { catchError, firstValueFrom, of, take } from 'rxjs';
import { CdsToastModule } from '@cds/ng-web-components/toast';
import { CdsOverlayModule } from '@cds/ng-web-components/core';

const script = document.createElement('script');
script.src = common_urls.adobeAnalyticsUrl;
document.head.appendChild(script);
const code = document.createElement('script');
code.innerHTML = `var adobeDataLayer=  adobeDataLayer|| [];`
document.head.appendChild(code);
const scriptNewRelic = document.createElement('script');
scriptNewRelic.src = common_urls.newRelicUrl;
scriptNewRelic.type = "text/javascript";
document.head.appendChild(scriptNewRelic);

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            AuthConfigModule,
            AppRoutingModule,
            TranslateModule.forRoot(translateConfig),
            BackButtonDisableModule.forRoot({
                preserveScroll: true
            }),
            CdsProgressModule,
            CdsToastModule,
            CdsOverlayModule,
            MatNativeDateModule
        ),
        FetchMenuService,
        {
            provide: Renderer2,
            useFactory: (rendererFactory2: RendererFactory2) => rendererFactory2.createRenderer(null, null),
            deps: [RendererFactory2]
        },
        {
            provide: APP_INITIALIZER,
            multi: true,
            deps: [OidcSecurityService],
            useFactory: (oidcSecurityService: OidcSecurityService) => {
                return () => firstValueFrom(
                    oidcSecurityService.checkAuth().pipe(
                        take(1),
                        catchError(() => of(null))
                    )
                );
            }
        },
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
